/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { TokenService } from 'src/app/auth/services/token/token.service';
import { CashRegisterService } from './cash-register.service';

@Component({
  selector: 'pg-cash-register-component',
  templateUrl: './cash-register.component.html',
  providers: [MessageService]
})
export class CashRegisterComponent {
  showOpenCashRegister = false;
  canOpenCashRegister = false;

  showCloseCashRegister = false;
  canCloseCashRegister = false;

  cashRegistersActive$: Subscription;

  token$: Subscription;
  cashRegisterCard: any = null;

  constructor(
    public messageService: MessageService,
    private cashRegisterService: CashRegisterService,
    private tokenService: TokenService
  ) {}

  ngOnInit() {
    this.cashRegistersActive$ = this.cashRegisterService
      .getData$()
      .subscribe((data) => {
        this.setCanActiveButtons();
        this.setCashRegisterCart(data);
      });
  }

  setCanActiveButtons() {
    const canSale = this.tokenService.getCanSale();
    if (canSale) {
      this.canOpenCashRegister = false;
      this.canCloseCashRegister = true;
    } else {
      this.canCloseCashRegister = false;
      this.canOpenCashRegister = true;
    }
  }
  setCashRegisterCart(cashRegister) {
    const fields = {
      branchStoreName: 'Sucursal',
      code: 'Código',
      seriesOfReceipts: 'Serie de Recibos',
      userNames: 'Usuario',
      openingDate: 'Fecha Apertura',
      initialBalance: 'Saldo Inicial',
      physicalBalance: 'Saldo Físico',
      cashSales: 'Ventas Efectivo',
      repayment: 'Reembolso'
    };

    if (cashRegister === undefined) {
      this.cashRegisterCard = Object.keys(fields).map((key) => {
        const label = fields[key];
        return { label, value: '-' };
      });
    } else {
      this.cashRegisterCard = Object.keys(fields).map((key) => {
        const label = fields[key];
        const value = cashRegister[key];
        return { label, value };
      });
    }
  }

  ngOnDestroy() {
    this.cashRegistersActive$.unsubscribe();
  }
}
